import { Controller } from "stimulus"

// A Stimulus controller to send PostHog events based on user interactions
export default class extends Controller {
  static values = {
    name: String,
    properties: Object,
    trigger: String
  }

  connect() {
    if (!this.isPostHogAvailable()) return
    if (!this.isValid()) return
    // Bind the handler once for correct removal later
    this.boundHandler = this.handleEvent.bind(this)
    this.element.addEventListener(this.triggerValue, this.boundHandler)
  }

  disconnect() {
    if (this.boundHandler) {
      this.element.removeEventListener(this.triggerValue, this.boundHandler)
    }
  }

  // Checks if PostHog is available in the global scope
  isPostHogAvailable() {
    if (typeof posthog === "undefined") {
      console.warn("[PostHog Controller] PostHog is not available.")
      return false
    }
    return true
  }

  // Validates required values
  isValid() {
    if (!this.nameValue || !this.triggerValue) {
      console.warn(
        "[PostHog Controller] Missing required values (name or trigger):",
        this.element
      )
      return false
    }
    return true
  }

  // Event handler for triggering PostHog capture
  handleEvent(event) {
    try {
      posthog.capture(this.nameValue, {
        ...this.propertiesValue
      })
      console.log(`[PostHog] Event captured: ${this.nameValue}`)
    } catch (error) {
      console.error("[PostHog Controller] Failed to capture event:", error)
    }
  }
}